module.exports = __webpack_public_path__ + "static/media/dark-material-bg.d914334b.jpg";